 
import React   from 'react' ;  
const   AdminFooter = ()=>{
 
  
   return (
     <>  
     <div className="row App">
        <hr/>
     <p>admin Footer </p>
      </div>
     </>
   )
    
} 
export default AdminFooter